var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sale-chart" }, [
    _c("div", { staticClass: "sale-chart__header" }, [
      _c("div", { staticClass: "text_large" }, [
        _vm._v(_vm._s(_vm.i18n.sale_investment_history()))
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "sale-chart__container" },
      [
        _c(
          "div",
          { staticClass: "sale-chart__labels" },
          [
            _c("scale-tabs", {
              attrs: { asset: _vm.asset, isPending: _vm.isPending },
              model: {
                value: _vm.scale,
                callback: function($$v) {
                  _vm.scale = $$v
                },
                expression: "scale"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.history.length
          ? _c("d3-chart", {
              staticClass: "sale-chart__chart",
              attrs: {
                data: _vm.history,
                currency: _vm.asset,
                scale: _vm.scale,
                isPending: _vm.isPending,
                precision: _vm.precision,
                requiredTicks: _vm.requiredTicks
              }
            })
          : _c("div", { staticClass: "chart-container__loader" }, [
              _vm._v("Loading...")
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b95c1dc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b95c1dc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/components/chart/ChartWidget.Index.vue
// module id = hkvJ
// module chunks = 1